import { api, getSessionId } from "./api";

let lastPath = null;

export function trackPageview(path) {
  if (path === lastPath) return;
  lastPath = path;
  api.post("/analytics/track", {
    event_type: "pageview",
    path,
    session_id: getSessionId(),
  }).catch(() => {});
}

export function trackClick(name, meta) {
  api.post("/analytics/track", {
    event_type: "click",
    name,
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    session_id: getSessionId(),
    meta,
  }).catch(() => {});
}

export function trackAdImpression(slot, meta) {
  api.post("/analytics/track", {
    event_type: "ad_impression",
    name: slot,
    session_id: getSessionId(),
    meta,
  }).catch(() => {});
}

export function trackAdClick(slot, meta) {
  api.post("/analytics/track", {
    event_type: "ad_click",
    name: slot,
    session_id: getSessionId(),
    meta,
  }).catch(() => {});
}
